// Rastreador central de estado de salvamento, para o indicador "Tudo salvo /
// Salvando… / Erro" e para avisar ao fechar com pendências.
//
// Considera duas fontes de "pendência":
//   * emVoo: escritas em andamento no Supabase (envolvidas por rastrear()).
//   * sujos: campos com edição digitada ainda não confirmada (marcarSujo até o
//     save bem-sucedido chamar marcarLimpo).
let emVoo = 0
const sujos = new Set()
let falhou = false
const subs = new Set()

function estado() {
  if (falhou) return 'erro'
  if (emVoo > 0 || sujos.size > 0) return 'salvando'
  return 'ok'
}

function notify() {
  const e = estado()
  subs.forEach(f => f(e))
}

// Assina mudanças de estado (chama de imediato com o estado atual).
export function onSaveStatus(cb) {
  subs.add(cb)
  cb(estado())
  return () => subs.delete(cb)
}

// Há algo pendente (em voo ou digitado e não salvo)?
export function temPendencias() {
  return emVoo > 0 || sujos.size > 0
}

// Marca/limpa um campo como "tem edição não confirmada".
export function marcarSujo(el) {
  if (el) {
    sujos.add(el)
    falhou = false
    notify()
  }
}
export function marcarLimpo(el) {
  if (el && sujos.delete(el)) notify()
}

// Envolve uma promessa de escrita: contabiliza enquanto roda e sinaliza falha.
export async function rastrear(promise) {
  emVoo++
  falhou = false
  notify()
  try {
    return await promise
  } catch (e) {
    falhou = true
    throw e
  } finally {
    emVoo--
    notify()
  }
}
